<div *transloco="let t;" class="play-section">
  <div class="notification-bar">
    <div class="no-kryptomon" *ngIf="!hasKryptomonV2 && !hasKryptomonV1">
      <p>{{t('play.noKryptomons')}}</p>
      <p>{{t('play.useKryptoFinder')}}</p>
      <div class="btn-finder" (click)="goToWizard()">Open KryptoFinder</div>
    </div>
    <div class="only-v1" *ngIf="!hasKryptomonV2 && hasKryptomonV1">
      <p>{{t('play.kryptomonsInLimbo')}}</p>
      <p>{{t('play.migrateToPlay')}}</p>
      <div class="btn-finder" (click)="goToKryptomons()">{{t('play.migrateKryptomons')}}</div>
    </div>
    <div class="some-v1" *ngIf="hasKryptomonV2 && hasKryptomonV1">
      <p>{{t('play.someKryptomonsInLimbo')}}</p>
      <div class="btn-finder" (click)="goToKryptomons()">{{t('play.migrateKryptomons')}}</div>
    </div>
    <div class="download-app" *ngIf="hasKryptomonV2 && !isMobile">
      <img src="./assets/img/Home/cellphone-wok.png" class="download-app-img-left" />
      <div class="download-app-content max-w-[488px]">
        <!-- <p>Remember, multiplayer works only on our Mobile App! Download it now:</p> -->
        <div class="user-content user-content-desktop">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Desktop.svg" />
          <p class="user-title">{{t('shared.desktop')}}:</p>
          <!-- <div class="line-sep"></div> -->
          <!-- <p class="user-text">{{t('play.loginCredentialMsg')}}</p> -->
          <div class="android-download download cursor-pointer ">
            <img class="h-[40px]" src="./assets/img/Home/play-trainer-hub.svg" />
          </div>
          <a class="android-download download relative cursor-pointer" [href]="windowExeUrl" target="_blank">
            <img class="h-[40px]" src="./assets/img/Home/play-windows.svg" />
            <img class="h-[25px] absolute top-[-9px] right-2" src="./assets/img/Home/alpha.svg" />
          </a>
        </div>
        <div class="user-content user-content-mobile">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Mobile.svg" />
          <p class="user-title">{{t('shared.mobile')}}:</p>
          <!-- <div class="line-sep"></div> -->
          <div class="download-buttons">
            <div class="android-download download min-w-[100px]" (click)="playAndroid()">
              <img src="./assets/img/Home/Button-Android.svg" />
            </div>
            <div class="android-download download min-w-[90px]" (click)="playiOs()">
              <img src="./assets/img/Home/Button-iOS.svg" />
            </div>
          </div>
          <!-- <p class="user-text">{{t('play.downloadApp')}}</p> -->
          <p class="user-text text-start">iOS users will get the game through Test Flight</p>
        </div>
      </div>
      <img src="./assets/img/Home/cellphones-game.png" class="download-app-img-right" />
    </div>
    <div class="download-app" *ngIf="hasKryptomonV2 && isMobile">
      <!-- <img src="./assets/img/Home/cellphone-wok.png" class="download-app-img-left" /> -->
      <div class="download-app-content">
        <!-- <p class="user-mobile-text">{{t('play.downloadAppNoWeb')}}</p> -->
        <!-- <div class="user-content user-content-desktop user-content-onmobile">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Desktop.svg" />
          <p class="user-title">{{t('shared.desktop')}}</p>
          <div class="line-sep"></div>
          <p class="user-text">{{t('play.loginCredentialMsg')}}</p>
        </div> -->
        <div class="user-content user-content-mobile flex-col user-content-onmobile">
          <img class="user-device-icon" src="./assets/img/Icon/Icon-Mobile.svg" />
          <p class="user-title">{{t('shared.mobile')}}</p>
          <div class="line-sep"></div>
          <p class="user-text">{{t('play.downloadApp')}}</p>
          <div class="download-buttons">
            <div class="android-download download cursor-pointer ">
              <img class="h-[40px]" src="./assets/img/Home/play-trainer-hub.svg" />
            </div>
            <a class="android-download download relative cursor-pointer" [href]="windowExeUrl" target="_blank">
              <img class="h-[40px]" src="./assets/img/Home/play-windows.svg" />
              <img class="alpha absolute top-[-7px] right-2" src="./assets/img/Home/alpha.svg" />
            </a>
          </div>
          <div class="download-buttons">
            <div class="android-download download" (click)="playAndroid()">
              <img src="./assets/img/Home/Button-Android.svg" />
            </div>
            <div class="android-download download" (click)="playiOs()">
              <img src="./assets/img/Home/Button-iOS.svg" />
            </div>
          </div>
        </div>
        <p class="user-text text-center text-sm">iOS users will get the game through Test Flight</p>

      </div>
      <img src="./assets/img/Home/cellphones-game.png" class="download-app-img-right" />
    </div>
  </div>
  <div class="game-frame" *ngIf="hasKryptomonV2 && !isMobile">
    <iframe [src]="iframeUrl" allowfullscreen=true webkitallowfullscreen=true mozallowfullscreen=true></iframe>
  </div>
</div>